// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"37de91a5","205":"f6b95e1c","269":"bcc77947","434":"b2fe2f19","637":"bcc77947","670":"bcc77947","771":"f11aa57c"}[chunkId] + ".chunk.css";
};